<script>
    import {mapGetters} from "vuex";

    export default {
        name: "BackgroundColorMixin",
        computed: {
            ...mapGetters('globalConfig', [
                'getGlobalColorStyles'
            ]),
            nodeWithColor () {
                return this.myNode
            }
        },
        methods: {
            getBackgroundColor() {
                return this.getStyleProperty("backgroundColor", {defaultValue: ""});
            },

            setBackgroundColor(value) {
                const classes = Object.keys(this.getGlobalColorStyles)
                    .filter(className => className.endsWith('-bg'));

                for (const className of classes) {
                    const color = this.getGlobalColorStyles[className].color;
                    if (color === value) {
                        this.applyClass({
                            newClass : className,
                            classesToRemove : classes,
                            update : true
                        })
                        this.applyStyle({ styleProp : "backgroundColor" , value : null });
                        return;
                    }
                }

                this.applyStyle({ styleProp: "backgroundColor", value: value });
            },

            toggleColorOnlyDisplay (flag) {
                if (flag) {
                    this.nodeWithColor.style.display = null;
                    //to display only the color of a div we have to remove any existing / default bg images
                    if (this.removeBgImage) {
                        this.removeBgImage();
                    }
                } else {
                    this.nodeWithColor.display = "false";
                }
            },
            showColor () {}
        }
    }
</script>
